import cssVars from 'css-vars-ponyfill'

const dhsvCommon = {
  stickyBanner() {
    let scrollTop
    const body = $('body')

    function handleScroll() {
      scrollTop = $(window).scrollTop()

      if (scrollTop <= 5) {
        body.removeClass('sticky-nav')
      } else {
        body.addClass('sticky-nav')
      }
    }

    if ($('#wpadminbar').length) {
      $(body).addClass('with-adminbar')
    }

    handleScroll()
    $(window).on('scroll', this.throttled(10, handleScroll))
  },
  throttled(delay, fn) {
    let lastCall = 0
    return function(...args) {
      const now = new Date().getTime()
      if (now - lastCall < delay) {
        return
      }
      lastCall = now
      return fn(...args)
    }
  },
  setBodyWidth() {
    cssVars({
      variables: { '--body-width': document.body.clientWidth + 'px' },
    })
  },
  smoothScroll(link, e) {
    let destination = 0

    if (e) e.preventDefault()
    var hash = false
    if (!link && window.location.hash) {
      hash = window.location.hash
    } else if (link && link.indexOf('#') == 0) {
      hash = link
    } else if (
      link &&
      location.pathname.replace(/^\//, '') ==
        link.pathname.replace(/^\//, '') &&
      location.hostname == link.hostname
    ) {
      hash = link.hash
    }

    if (hash && $(hash).length) {
      destination = $(hash).offset().top - 75
      history.replaceState(null, null, hash)
    }

    $('html, body').animate(
      {
        scrollTop: destination,
      },
      600
    )

    $(window).trigger('hashchange')
  },
  gfieldButtonsRemove() {
    $('.gform_wrapper ').each(function() {
      if ($(this).find('.gfield .btn').length > 0) {
        $(this)
          .find('.gform_footer')
          .css({
            position: 'absolute',
            left: '-9999px',
          })
      }
    })
  },
  gfieldAnswerPopup() {
    $('li.gfield.question-circle .ginput_container').append(
      '<div class="question-circle-icon"></div>'
    )
    $(document).on(
      'click',
      'li.gfield.question-circle .ginput_container .question-circle-icon',
      function() {
        // eslint-disable-next-line no-console
        console.log('mouseenter event fired')
        $(this)
          .parent()
          .parent()
          .find('.gfield_description')
          .toggleClass('gfield_description_show')
      }
    )
  },
  primaryMenuInit() {
    $('body').on('click', '.js-nav-toggler', function() {
      $(this).toggleClass('toggled')
      if ($('.js-nav-primary:visible').length) {
        $('.js-nav-primary')
          .css('opacity', 0)
          .hide()
          .removeClass('is-open')
        $('.js-language-switcher, .searchform-wrapper').removeClass('active')
        $('.dropdown-toggle').css('position', 'relative')
      } else {
        $('.js-nav-primary')
          .show()
          .addClass('is-open')
        $('.js-nav-primary').css('opacity', 1)
        $('.js-language-switcher, .searchform-wrapper').addClass('active')
      }
      $('.body-container').toggleClass('menu-open')
    })
    $('.js-back-btn').click(function(ev) {
      ev.preventDefault()
      $(this)
        .closest('.dropdown-menu')
        .removeClass('show')
      $(this)
        .closest('li.dropdown')
        .find('.dropdown-toggle')
        .css('position', 'relative')
        .attr('aria-expanded', 'false')
      $('.nav-link, .banner__contact').removeClass('inactive')
    })
    $('.dropdown-toggle').click(function() {
      $(this).css('position', 'static')
    })
    $(window).resize(function() {
      if ($(window).width() > 991) {
        $('.js-nav-primary').css({
          display: 'block',
          opacity: 1,
        })
      } else {
        $('.js-nav-primary').css({
          display: 'none',
          opacity: 0,
        })
        $('.js-nav-toggler').removeClass('toggled')
        $('.js-language-switcher, .searchform-wrapper').removeClass('active')
      }
    })
  },
  lettersToSpans(className) {
    if (!$(className).hasClass('scaned')) {
      $(className)
        .addClass('scaned')
        .html(function(i, html) {
          let chars = $.trim(html).split('')
          chars.map(function(el, i) {
            if (el == '­') {
              chars[i] = '<span class="hyphen">-</span>'
            } else if (el == '&') {
              chars[i] = '<span class="char">&</span>'
              chars[i + 1] = ''
              chars[i + 2] = ''
              chars[i + 3] = ''
              chars[i + 4] = ''
            } else {
              chars[i] = '<span class="char">' + el + '</span>'
            }
          })
          return chars.join('')
        })
    }
  },
  searchToggle() {
    $('.js-search-button').on('click', function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
      } else {
        $(this).addClass('active')
      }
      $('.searchform-wrapper').toggleClass('opened')
    })

    $('body').click(function() {
      $('.searchform-wrapper').removeClass('opened')
    })

    $('.searchform-wrapper').click(function(e) {
      e.stopPropagation()
    })
  },
  primaryMenuHandler() {
    $('.dropdown-menu').click(function(e) {
      e.stopPropagation()
    })
    $('.menu-item-has-children .nav-link').click(function() {
      setTimeout(function() {
        if ($('.dropdown-menu.show').length) {
          $('body').addClass('dropdown-menu-open')
        } else {
          $('body').removeClass('dropdown-menu-open')
          $(
            '.nav-link, .banner__contact, .js-language-switcher, .search-button, .twitter-link'
          ).removeClass('inactive')
        }
      }, 0.05)
      $('.searchform-wrapper').removeClass('opened')
      $(this).removeClass('inactive')
      $('.nav-link')
        .not(this)
        .addClass('inactive')
      $(
        '.banner__contact, .js-language-switcher, .search-button, .twitter-link'
      ).addClass('inactive')
    })
    $('body').click(function() {
      setTimeout(function() {
        if (!$('.dropdown-menu.show').length) {
          $(
            '.nav-link, .banner__contact, .js-language-switcher, .search-button, .twitter-link'
          ).removeClass('inactive')
          $('body').removeClass('dropdown-menu-open')
        }
      }, 0.05)
    })
  },
  countHandler() {
    $({ countNum: $('.js-count').text() }).animate(
      { countNum: $('.js-count').data('count') },
      {
        duration: 4000,
        easing: 'linear',
        step: function() {
          // $('.js-count').text(Number.parseFloat(this.countNum).toFixed(2))
          $('.js-count').text(Math.floor(this.countNum))
        },
        complete: function() {
          $('.js-count').text(this.countNum)
        },
      }
    )
  },
  acoordionHandler() {
    let clicks = true
    $('.js-accordion-title').on('click', function() {
      // const wrapper = $(this).closest('.js-accordion')
      const parent = $(this).closest('.js-accordion-item')
      if (parent.hasClass('active')) {
        $('.js-accordion-item').removeClass('active')
        $('.js-accordion-hidden').slideUp()
      } else {
        $('.js-accordion-item').removeClass('active')
        $('.js-accordion-hidden').slideUp()
        parent
          .addClass('active')
          .find('.js-accordion-hidden')
          .slideDown()
      }
      if (!$('.js-accordion-item.active').length) {
        $('.js-open-all').removeClass('open')
        clicks = true
      }
    })
    $('.js-open-all').click(function() {
      if (clicks) {
        $(this).addClass('open')
        clicks = false
        $('.js-accordion-item').addClass('active')
        $('.js-accordion-hidden').slideDown()
      } else {
        $(this).removeClass('open')
        clicks = true
        $('.js-accordion-item').removeClass('active')
        $('.js-accordion-hidden').slideUp()
      }
    })
  },
  equalAnimation() {
    const equalNode = $('.js-equal')
    if ($(equalNode).length) {
      const headerNode = $('.banner')
      const green = $('.js-green')
      const titleNode = $('.js-equal-title')
      const anchorsNode = $('.js-equal-anchors')
      headerNode.addClass('transparent')
      setTimeout(function() {
        green.addClass('active')
        equalNode.removeClass('on-top')
      }, 500)
      setTimeout(function() {
        headerNode.removeClass('transparent')
        anchorsNode.removeClass('transparent')
        titleNode.removeClass('transparent')
      }, 2100)
    }
  },
  initSections() {
    $('.hero-equal').length &&
      $('.vc_section').each(function() {
        let classes = $(this).attr('class')
        const res = classes
          .replace('vc_section', '')
          .replace('padding', '')
          .replace('margin_bottom', '')
          .replace('pull_up', '')
          .replace('inner_container', '')
          .replace('center_line', '')
          .replace(/ /g, '')
        $(this).attr('data-body-class', res)
      })
  },
  sectionScroll() {
    const winH = $(window).height()

    function bodyBg(scrollTop) {
      $('.vc_section').each(function() {
        const offset = $(this).offset()
        const classes = $(this).attr('data-body-class')
        const body = $('body').attr('data-bg')
        if (scrollTop + winH / 3 > offset.top && body !== classes) {
          $('body').attr('data-bg', classes)
        }
      })
    }

    if ($('.hero-equal').length) {
      $(window).scroll(function() {
        const scrollTop = $(window).scrollTop()
        bodyBg(scrollTop)
      })
      $('body').addClass('equal-opportunity-page')
    }
  },
  bodyAddClassEqual() {
    if ($('.hero-equal').length) {
      $('body').addClass('equal-opportunity-page')
    }
  },
  discussionPaperForm() {
    const gformUploadNode = $('.ginput_container_fileupload').closest('.gfield')
    const chosenCnanges = () => {
      $('.chosen-drop').append(`
      <div class="chosen-btn">
        <a href="#" class="btn js-chosen-select">CONFIRM SELECTION</a>
      </div>
      `)
      $('.js-chosen-select').click(function(ev) {
        ev.preventDefault()
        $('.chosen-container').removeClass('active chosen-container-active')
      })

      $('.chosen-search-input').replaceWith(function() {
        return $(
          '<p class="chosen-search-main-title">' +
            $('.chosen-container')
              .closest('.ginput_container')
              .find('select')
              .data('placeholder') +
            '</p>'
        )
      })
      $('html').click(function() {
        if ($('.chosen-container').hasClass('chosen-container-active')) {
          $('.chosen-container').addClass('active')
        }
      })
      $($('.chosen-container')).click(function(event) {
        event.stopPropagation()
      })
    }
    const uploadChanges = () => {
      const fileuploadName = gformUploadNode.find('.gfield_label').text()
      gformUploadNode.find('input.button').val(fileuploadName)

      $(document).on('gform_post_render', function() {
        $('.ginput_container_fileupload')
          .find('input.button')
          .val(fileuploadName)
      })
    }
    if ($('.chosen-container').length) {
      chosenCnanges()
      $(document).on('gform_post_render', function() {
        chosenCnanges()
      })
    }
    if (gformUploadNode.length) {
      uploadChanges()
    }
  },
  topButton() {
    $('.js-to-top').click(function() {
      $('html, body').animate(
        {
          scrollTop: $($(this).attr('href')).offset().top,
        },
        500
      )
      return false
    })
  },
  keepHashOnLanguageSwitch() {
    // WPML renders the switcher server-side and never sees the fragment,
    // so carry the current hash over to the translated URL on the client.
    const links = $('.js-language-switcher a[href]').not('[href^="#"]')

    if (!links.length) return

    const applyHash = () => {
      const hash = window.location.hash

      links.each((i, el) => {
        const $link = $(el)
        const base = $link.data('hrefBase') || $link.attr('href').split('#')[0]

        $link.data('hrefBase', base)
        $link.attr('href', base + hash)
      })
    }

    applyHash()
    $(window).on('hashchange', applyHash)
    // VC tab anchors (#podcast, #news, …) rewrite the hash without firing
    // hashchange, so refresh again right before the link is actually used
    links.on('mousedown touchstart focus mouseenter contextmenu', applyHash)
  },
  init() {
    this.stickyBanner()
    this.primaryMenuInit()
    this.setBodyWidth()
    this.lettersToSpans('.btn-link, .js-research-area')
    this.searchToggle()
    this.gfieldButtonsRemove()
    this.gfieldAnswerPopup()
    this.primaryMenuHandler()
    this.countHandler()
    this.acoordionHandler()
    this.equalAnimation()
    this.initSections()
    this.sectionScroll()
    this.bodyAddClassEqual()
    this.keepHashOnLanguageSwitch()
    //this.discussionPaperForm()

    if (window.location.hash) {
      this.smoothScroll(window.location.hash)
    }
    $('body').on(
      'click',
      'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-toggle],[role="tab"],[data-vc-accordion],[data-vc-tabs])',
      e => {
        this.smoothScroll($(e.currentTarget).attr('href'), e)
      }
    )
    jQuery(document).on('gform_post_render', function() {
      setTimeout(function() {
        dhsvCommon.gfieldButtonsRemove()
      }, 500)
    })

    $(document).ready(function() {
      $('body').removeClass('not_visible')
    })
  },
  onResize() {
    $(window).on('resize', () => {
      this.setBodyWidth()
      this.equalAnimation()
    })
  },
}

export default {
  init() {
    // JavaScript to be fired on all pages
    dhsvCommon.init()
    dhsvCommon.onResize()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  lettersToSpan(selector = '.btn-link:not(.scaned), .underline:not(.scaned)') {
    dhsvCommon.lettersToSpans(selector)
  },
}
